<template>
<div
    class="my-container"
>
    <div
        class="chip-container"
    >
        <v-chip
            v-for="(item, key) in value"
            :key="'chip_'+key"
            close
            class="chip"
            v-on:click:close="onClickFilterClose(item)"
            v-on:click="onClickFilter(item)"
        >
            <span
                style="text-decoration: underline; color: #F14652"
            >
                {{prettyPrintFilter(item)}}
            </span>
        </v-chip>
    </div>

    <div
        class="menu-container"
    >
        <v-menu 
            bottom 
            offset-y  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-filter-plus-outline
            </v-icon>
                
        </template>
        
        <v-list>
            <v-list-item
                v-for="(item, key) in filter_options"
                :key="'menu_key_'+key"
                v-on:click="onClickAddFilter(item)"
            >
                <v-list-item-title>{{item.column_label}}...</v-list-item-title>
            </v-list-item>
        
        </v-list>
        
        </v-menu> 
    </div>

    <m-search-filter-edit-dialog
        ref="edit-search-filter-dialog"
        v-on:ok="onEditFilter"
    />

</div>
</template>

<script>
const _ = require('lodash');
export default {
    props: {
        value: {
            type: Array,
            default: function() { return []; },
        },
        filter_options: {
            type: Array,
            default: function() { return []; },
        },
    },

    data() {
        return {
        }
    },

    methods: {
        onClickAddFilter(item) {
            this.$refs['edit-search-filter-dialog'].showDialog(item, null);
        },

        onEditFilter(item)
        {
            let value = _.cloneDeep(this.value);

            for ( let i = 0; i < value.length; i++ )
            {
                if ( value[i].column_id == item.column_id )
                {
                    value[i] = _.cloneDeep(item);
                    this.$emit('input', value);
                    return;
                }
            }

            // If here, then it is a new filter...
            value.push(item);
            this.$emit('input', value);
        },

        prettyPrintFilter(item)
        {
            let values = '';

            if ( item.values.length == 1 )
            {
                values = item.values[0];
            }

            if ( item.values.length == 2 && item.type == 'in-range-inclusive' )
            {
                values = item.values[0] + ' to '+item.values[1];
            }

            return item.column_label+": "+values;
        },

        onClickFilterClose(item)
        {
            let value = _.cloneDeep(this.value)
                    .filter((cur_item) => !(cur_item.column_id == item.column_id));

            this.$emit('input', value);
        },

        onClickFilter(item)
        {
            let filter_options = this.filter_options.find((el) => el.column_id == item.column_id);

            this.$refs['edit-search-filter-dialog'].showDialog(filter_options, item);
        },
    },
}
</script>

<style lang="scss" scoped>
.my-container
{
    display: flex;
    margin-bottom: 10px;
}
.chip-container
{
    flex-grow: 1;
}
.menu-container
{
    flex-grow: 0;
}

.chip
{
    margin-bottom: 5px;
}
</style>